import React from "react"
import Scene from "components/scene"
import Lines from "components/lines"
import Reels from "components/reels"
import Overlay from "components/overlay"
import Highlighters from "components/highlighters"
import { GameProvider } from "utils/game-context"
import { TextureProvider } from "utils/texture-context"

const App = () => (
  <GameProvider>
    <Scene>
      <Lines />
      <TextureProvider>
        <Reels />
        <Highlighters />
      </TextureProvider>
      <Overlay />
    </Scene>
  </GameProvider>
)

export default App
